'use strict';

var _ = require('lodash');
var ConfigurationMarketClassFareTransformerFactory = function ConfigurationMarketClassFareTransformerFactory(DataTransformer, momentService) {
  function ConfigurationMarketClassFareTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-market-class-fare-mode';
    this.priority = 1;
  }
  ConfigurationMarketClassFareTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationMarketClassFareTransformer.constructor = ConfigurationMarketClassFareTransformer;
  ConfigurationMarketClassFareTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationMarketClassFareTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationMarketClassFareTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationMarketClassFareTransformer.prototype.transform = function (data) {
    var memorizedMomentOfApplicableDateRange = _.memoize(getMomentOfDate);
    if (data.domain.results) {
      var results = _.transform(data.domain.results, function (result, item) {
        var newEntity = {
          "class": item.className,
          origin: item.marketOrigin,
          destination: item.marketDestination,
          fare: item.fare,
          effectiveDate: memorizedMomentOfApplicableDateRange(item.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE),
          discontinueDate: memorizedMomentOfApplicableDateRange(item.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE),
          surcharge: item.surcharge,
          totalFare: item.totalFare
        };
        result.push(newEntity);
      });
      return results;
    } else {
      return [];
    }
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return ConfigurationMarketClassFareTransformer;
};
ConfigurationMarketClassFareTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationMarketClassFareTransformerFactory;